import React, { useState } from "react";

const FixedWidthSwitchComponent = ({
  label,
  checked,
  setChecked,
  disabled,
}) => {
  return (
    <div className="disp-flex-col">
      <div className="disp-flex-row">
        <p className="marg-right-20 ft-14-fw-400 grey-text">{label}</p>
      </div>
      <div className="section-component disp-flex-row pad-bot-15">
        <div
          className="custom-control custom-switch marg-right-50 disp-flex-col"
          onClick={!disabled && setChecked}
        >
          <input
            type="checkbox"
            className="custom-control-input"
            name={`radio-buttons`}
            checked={checked}
          />
          <label
            className="custom-control-label"
            htmlFor="customSwitchesChecked"
          >
            {null}
          </label>
        </div>
      </div>
    </div>
  );
};

export default FixedWidthSwitchComponent;
